import { Injectable } from '@angular/core';
import { NotTranslatedProvider } from '../providers/not-translated/not-translated';
import { MissingTranslationHandlerParams, MissingTranslationHandler } from '@ngx-translate/core';

@Injectable()
export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    this.nts.notTranslated(params.key);
    return params.key;
  }

  constructor(private nts: NotTranslatedProvider) {}
}



// WEBPACK FOOTER //
// ./src/translate/CustomMissingTranslationHandler.ts